import DataFunctions from '@/assets/DataFunctions.js'
import DataManager from '@/assets/DataManager.js'
import LiveData from '@/assets/LiveData.js'
import Dato from '@/assets/Dato.js'
import ContentController from '@/assets/ContentController.js'
import DeviceCheck from '@/assets/DeviceCheck.js'
import MapPopup from '@/components/map/MapPopup.vue'
import Vue from 'vue'
const MapPopupTemplate = Vue.extend(MapPopup)

const MarkerGenerator = {
  userWishStyles: [
    ["151","Bænk",["#00643F","BK","baenk.svg"]],
    ["152","Borde-bænkesæt",["#009149","BB","bordebaenke.svg"]],
    ["153","Anden opholdsmulighed",["#97BF0D","AO","anden_opholdsmulighed.svg"]],
    ["154","Lydfyr",["#FFDC00","LF","lydfyr.svg"]],
    ["155","Ledelinje ",["#A7172B","LL","ledelinje.svg"]],
    ["164","Tilgængelighed med nedsat syn",["#A7172B","NS","nedsat_syn.svg"]],
    ["156","Handicapparkering",["#0096CE","HP","handicapparkering.svg"]],
    ["157","Kantstensrampe",["#OO2E5E","KR","kanstensrampe.svg"]],
    ["158","Forbedret krydsningsmulighed",["#B1ABA5","FK","krydsningsmulighed.svg"]],
    ["159","Fjerne barriere/forhindring ",["#E6177A","FB","fjerne_barriere.svg"]],
    ["160","Sti",["#BBD7F3","NS","sti.svg"]],
    ["161","Fortov",["#CDA000","NF","fortov.svg"]],
    ["165","Belysning",["#FFDC00","BE","belysning.svg"]],
    ["162","Andre ønsker",["#B1ABA5","AØ","andet.svg"]]
  ],

  generateMarker: function(feature, latLng, opacity) {
    return new Promise((resolve) => {
      DataFunctions.findPrimaryTag(feature).then((tag) => {
        if(feature.geometry.icon != undefined && MarkerGenerator.isSign(feature.geometry.icon)) {
          feature.isSign = true;
        }
      	var iconInfo = JSON.parse(tag.icon);
      	var fill = 'rgb(0,112,141)';
      	var markerIcon = '<span class="marker-text"></span>';
      	var iconRoot = 'https://apps.odenserundt.dk/media/icons/';
      	var svgMarker;
      	var closed = '';
        var opacityValue = opacity ? 0.6 : 1;
      	//If the feature is a oneway, road closure etc.
      	if(tag.id == 16 && feature.geometry.icon || tag.id == 49 && feature.geometry.icon || tag.id == 50 && feature.geometry.icon || tag.id == 53 && feature.geometry.icon || feature.isSign) {
      		svgMarker = MarkerGenerator.createRoadSignIcon(feature, iconRoot, tag);
      	}
      	else if(tag.id == 115 || tag.id == 117) {
      		svgMarker = MarkerGenerator.createRoadworkIcon(feature, iconRoot, tag);
      	}
      	//Bus stop
      	else if(tag.id == 371) {
      		var busStopHtml = '<div class="bus-stop-icon"></div>';
      		svgMarker = L.divIcon({className: 'bus-stop-marker', iconAnchor: [15, 15], html: busStopHtml});
      	}
      	else {
      		//Parkering
      		if(tag.id == 51 || tag.id == 377) {
      			var outsideOpeningHours = MarkerGenerator.checkIfOutsideOpeningHours(feature);
      			fill = outsideOpeningHours ? 'rgb(177,171,165)' : LiveData.findParkingColor(feature);
      			markerIcon = LiveData.findParkingText(feature);
      			closed = MarkerGenerator.checkIfClosed(feature);
      		}
      		//Handicapparkering
      		else if(tag.id == 56) {
            fill = iconInfo.color;
      			if(feature.properties.prop52) {
      				if(feature.properties.prop52.option_id == 135 || feature.properties.prop52.option_id == 129) {
      					fill = '#565656';
      				}
      			}
      			if(iconInfo.type == 'file') {
      				if(iconInfo.file != '' && iconInfo.file != null && iconInfo.file != undefined) {
      					markerIcon = '<img src="https://apps.odenserundt.dk/media/icons/'+iconInfo.file+'" alt="Kort ikon for handicapparkering">';
      				}
      			}
      			else if(iconInfo.char != '' && iconInfo.char != null && iconInfo != undefined) {
      				markerIcon = '<span class="marker-text">'+iconInfo.char+'</span>';
      			}
      		}
      		else if(tag.id == 36) {
      			fill = MarkerGenerator.findBenchColor(feature);
      			markerIcon = MarkerGenerator.findBenchIcon(feature);
      		}
      		else if(tag.id == 342) {
      			fill = MarkerGenerator.findUserWishColor(feature);
      			markerIcon = MarkerGenerator.findUserWishIcon(feature);
      		}
      		else if(iconInfo != null && iconInfo != 0 && iconInfo != '') {
      			if(iconInfo.color != null && iconInfo.color != 0 && iconInfo.color != '') {
      				fill = iconInfo.color;
      			}

      			if(iconInfo.type == 'file') {
      				if(iconInfo.file != '' && iconInfo.file != null && iconInfo.file != undefined) {
      					markerIcon = '<img src="https://apps.odenserundt.dk/media/icons/'+iconInfo.file+'" alt="Kort ikon">';
      				}
      			}
      			else if(iconInfo.char != '' && iconInfo.char != null && iconInfo != undefined) {
      				if(iconInfo.showNameInIcon && iconInfo.showNameInIcon == true) {
      					markerIcon = '<div class="marker-name-text-icon">'+iconInfo.char+'</div>';
      				}
      				else {
      					markerIcon = '<span class="marker-text">'+iconInfo.char+'</span>';
      				}
      			}
      		}
      		var markerHtml = '';
      		if(tag.id == 51 || tag.id == 56 || tag.id == 236 || tag.id == 266 || tag.id == 93 || tag.id == 377) {
      			markerHtml = '<div class="marker">\
      											<div class="parking-icon" style="background-color: '+fill+'">\
      												<div class="marker-icon">'+markerIcon+'</div>\
      											'+closed+'</div>\
      										</div>';
      		}
      		//If the feature is a area like city areas
      		else if(iconInfo.showNameInIcon && iconInfo.showNameInIcon == true) {
      			markerHtml = '<div class="marker-name" style="background-color:'+fill+'">\
      											<div class="marker-name-bg">\
      												'+markerIcon+'\
      												<span class="marker-name-text">'+feature.name+'</span>\
      											</div>\
      										</div>';
      		}
      		else {
      		 	markerHtml = '<div class="marker"><div class="round-icon" style="background-color:'+fill+'"></div></div><div class="marker-icon-bg"><div class="marker-icon">'+markerIcon+'</div>'+closed+'</div>';
      		}

      		var drawHat = false;
      		if(feature.properties.prop62) {
      			if(feature.properties.prop62.value[0].value == true && feature.properties.prop62.value[1].value != true && feature.properties.prop62.value[2].value != true) {
      				markerHtml += '';
      			}
      			else { drawHat = true }
      		}
      		if(feature.properties.prop115) {
      			if(feature.properties.prop115.value[2].value == true || feature.properties.prop115.value[3].value == true || feature.properties.prop115.value[4].value == true) {
      				drawHat = true;
      			}
      			else { markerHtml += ''; }
      		}

      		if(drawHat) {
      			markerHtml += '<div class="marker-hat rotate-left-90"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\
      				viewBox="0 0 404.258 404.258" style="fill:'+fill+';" xml:space="preserve">\
      				<polygon points="138.331,0 114.331,18 252.427,202.129 114.331,386.258 138.331,404.258 289.927,202.129 "/>\
      			</svg></div>';
      		}

      		if(iconInfo.showNameInIcon && iconInfo.showNameInIcon == true) {
      			svgMarker = L.divIcon({className: 'name-marker', iconAnchor: [0, 0], html: markerHtml});
      		}
      		else {
      			svgMarker = L.divIcon({className: 'svg-div-marker', iconAnchor: [22.5, 22.5], html: markerHtml});
      		}
      	}
        feature.marker = new L.marker(latLng, {icon: svgMarker, opacity: opacityValue});
      	resolve();
      });
    });
  },

  createRoadSignIcon: function(feature, iconRoot, tag) {
  	var icon;
  	var preWarning = false;
  	if(feature.properties.prop89) {
  		preWarning = MarkerGenerator.checkWarningPeriod(feature);
  	}
  	if(preWarning == true) {
  		var filename = feature.geometry.icon.replace('.png', '_forvarsling.svg');
  		icon = L.icon({iconAnchor: [15, 15], iconUrl: iconRoot+'forvarsling/'+filename, iconSize: [27, 27], className: 'route-point-marker'});
  	}
  	else {
  		var filename = feature.geometry.icon.replace('.png', '.svg');
  		icon = L.icon({iconAnchor: [15, 15], iconUrl: iconRoot+'roadsigns/'+filename, iconSize: [27, 27], className: 'route-point-marker'});
  	}

  	return icon;
  },

  createRoadworkIcon: function(feature, iconRoot, tag) {
    var filename;
		var preWarning = false;
		if(feature.properties.prop89) {
			preWarning = MarkerGenerator.checkWarningPeriod(feature);
		}
		if(tag.id == 115) {
			if(preWarning == true) { filename = 'vejarbejde_forvarsling.svg';	}
			else { filename = 'vejarbejde.svg';	}
		}
		else {
			if(preWarning == true) { filename = 'trafikinfo_forvarsling.svg';	}
			else { filename = 'trafikinfo.svg';	}
		}

		//Class for Z-index fix for traffic work and information
		var icon = L.icon({iconAnchor: [15, 15], iconUrl: iconRoot+filename, iconSize: [30, 30], className: 'route-point-marker'});

    return icon;
  },

  generateCityDevIcon: function(feature, latLng) {
    return new Promise((resolve) => {
    	DataFunctions.getTagById(231).then((tag) => {
      	var icon = JSON.parse(tag.icon);
      	var svgMarker;
      	var markerHtml;
      	var imageValue = '';

      	if(feature.properties.prop25) {
      		imageValue = '<div class="marker-image" style="background-image: url(\'https://apps.odenserundt.dk/media/images/thumbnails/'+feature.properties.prop25.value[0].src+'\');"></div>';
      	}

      	markerHtml = '<div class="marker-name" style="background-color:'+icon.color+'">\
      								<div class="marker-name-bg">\
      									<span class="marker-name-text">'+feature.name+'</span>\
      								</div>\
      							</div>'+imageValue;

      	if(feature.properties.prop25) {
      		svgMarker = L.divIcon({className: 'image-marker', iconAnchor: [50, 50], html: markerHtml});
      	}
      	else {
      		svgMarker = L.divIcon({className: 'name-marker', iconAnchor: [0, 0], html: markerHtml});
      	}

      	feature.marker = new L.marker(latLng, {icon: svgMarker});
        resolve();
      });
    });
  },

  //Add event listener that generates popup content on click
  generatePopup: function(feature, layer, map) {
    layer.off('click');
  	layer.on('click', function(e) {
  		//app.savedPopup = feature;
  		DataFunctions.findPrimaryTag(feature).then((primaryTag) => {
        DataFunctions.getFeatureById(primaryTag.id, feature.id).then((result) => {
          var popupContent = new MapPopupTemplate({
            propsData: {
                feature: result,
                tagId: primaryTag.id
            }
          }).$mount().$el;

          var point = map.latLngToContainerPoint(e.latlng);
          var newPoint = L.point([point.x, point.y -10]);
          var newCoords = map.containerPointToLatLng(newPoint);
          var popup = L.popup({'className': 'map-popup', closeButton: false, autoPan: false}).setLatLng(newCoords).setContent(popupContent).openOn(map);
          var px = map.project(popup._latlng); // find the pixel location on the map where the popup anchor is
          px.y -= (popup._container.clientHeight/2) + ((DeviceCheck.isMobile) ? 60 : 45); // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
          map.panTo(map.unproject(px),{animate: true}); // pan to new center
        });
    	});
    });
  },

  generateListMarker: function(tag) {
  	//console.log(tag);
  	if(tag != undefined) {
  		var iconInfo = JSON.parse(tag.icon);
  		var fill = 'rgb(0,112,141)';
  		var markerIcon = '<span class="list-icon-text"></span>';
  		var iconRoot = 'https://apps.odenserundt.dk/media/icons/';
  		//If the feature is a oneway, road closure etc.
  		if(tag.id == 16 || tag.id == 49 || tag.id == 50 || tag.id == 53) {
  			var filename = '';
  			switch(tag.id) {
  				case '16':
  					filename = 'vl1.svg';
  					break;
  				case '49':
  					filename = 'e1.svg';
  					break;
  				case '50':
  					filename = 'hf1.svg';
  					break;
  				case '53':
  					filename = 'l1.svg';
  					break;
  			}
  			return '<div class="list-icon"><img src="'+iconRoot+'roadsigns/'+filename+'" alt="Vejskilt ikon"/></div>';
  		}
  		else if(tag.id == 115 || tag.id == 117) {
  			var filename = (tag.id == 115) ? 'vejarbejde.svg' : 'trafikinfo.svg';
  			return '<div class="list-icon"><img src="'+iconRoot+filename+'" alt="Vejarbejde eller trafikinformation ikon"/></div>';
  		}
  		else if(tag.id == 51 || tag.id == 56 || tag.id == 236 || tag.id == 266 || tag.id == 93) {
  			fill = 'rgb(000, 180, 215)';
  			markerIcon = 'P';

  			if(iconInfo != null && iconInfo != 0 && iconInfo != '') {
  				if(iconInfo.color != null && iconInfo.color != 0 && iconInfo.color != '') {
  					fill =	iconInfo.color;
  				}
  				if(iconInfo.type == 'file') {
  					if(iconInfo.file != '' && iconInfo.file != null && iconInfo.file != undefined) {
  						markerIcon = '<img src="https://apps.odenserundt.dk/media/icons/'+iconInfo.file+'" alt="Parkering ikon">';
  					}
  				}
  				else if(iconInfo.char != '' && iconInfo.char != null && iconInfo != undefined) {
  					markerIcon = '<span class="list-icon-text">'+iconInfo.char+'</span>';
  				}
  			}

  			return '<div class="list-icon">\
									<div class="parking-icon" style="background-color: '+fill+'">\
										<div class="marker-icon">'+markerIcon+'</div>\
									</div>\
								</div>';
  		}
  		else {
        if(iconInfo != null && iconInfo != 0 && iconInfo != '') {
          if(iconInfo.color != null && iconInfo.color != 0 && iconInfo.color != '') {
          	fill =	iconInfo.color;
          }
          if(iconInfo.type == 'file') {
          	if(iconInfo.file != '' && iconInfo.file != null && iconInfo.file != undefined) {
          		markerIcon = '<img src="https://apps.odenserundt.dk/media/icons/'+iconInfo.file+'" alt="Kort ikon">';
          	}
          }
          else if(iconInfo.char != '' && iconInfo.char != null && iconInfo != undefined) {
          	markerIcon = '<span class="list-icon-text">'+iconInfo.char+'</span>';
          }
  			}
  			return '<div class="list-icon" style="background-color: '+fill+';"><div class="list-icon-bg"></div><div class="list-icon-icon">'+markerIcon+'</div></div>';
  		}
  	}
  	else {
  		return '<div class="list-icon" style="background-color: rgb(0,112,141);"><div class="list-icon-bg"></div><div class="list-icon-icon"><span class="list-icon-text">?</span></div></div>';
  	}
  },

  checkIfOutsideOpeningHours: function(feature) {
  	if(feature.properties.prop74) {
  		var date = new Date();
  		var parkingDay;
  		var day = date.getDay();
  		var timeNow = date;

  		if(day > 0 && day < 6) {
  			parkingDay = 0; // Hverdag
  		}
  		else if (day == 6) {
  			parkingDay = 1; // Lørdag
  		}
  		else if(day == 0) {
  			parkingDay = 2; // Søndag
  		}

  		if(feature.properties.prop74.value.length != 0) {
  			//console.log(feature);
  			if(typeof feature.properties.prop74.value[parkingDay] === 'undefined') {
  				return false;
  			}
  			if(feature.properties.prop74 && feature.properties.prop74.value[parkingDay].to != '' && feature.properties.prop74.value[parkingDay].from != '') {
  				var from = feature.properties.prop74.value[parkingDay].from.split(':');
  				var openingPeriodStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), from[0], from[1], '00', '000');
  				var to = feature.properties.prop74.value[parkingDay].to.split(':');
  				var openingPeriodEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), to[0], to[1], '00', '000');

  				if(openingPeriodEnd < openingPeriodStart) { // Hvis endtime er mindre en starttime er vi i natte timer.
  					//var nextDay = day+1;
  					openingPeriodEnd.setDate(openingPeriodEnd.getDate()+1);
  					//openingPeriodEnd = nextDay+':'+feature.properties.open_hours[parkingDay].to+':00';
  				}
  				//console.log(timeNow + " :: " + openingPeriodStart + " - " + openingPeriodEnd + " = " + (timeNow > openingPeriodStart && timeNow < openingPeriodEnd));
  				if(timeNow > openingPeriodStart && timeNow < openingPeriodEnd) { // Skal være større end Start og mindre end End.
  					return false;
  				} else {
  					return true;
  				}
  			}
  			else {
  				return false;
  			}
  		}
  		else {
  			return false;
  		}
  	}
  },

  checkIfClosed: function(feature) {
  	if(feature.properties.prop88) {
  		if(feature.properties.prop88.value == 'Permanent' || feature.properties.prop88.value == 'Midlertidigt') {
  			return '<div class="closed-line"></div>';
  		}
  		else {
  			return '';
  		}
  	}
  	else {
  		return '';
  	}
  },

  getLineColors: function(feature, lineOpacityValue) {
    return new Promise((resolve) => {
    	DataFunctions.findPrimaryTag(feature).then((tag) => {
      	var iconInfo = JSON.parse(tag.icon);
      	var lineColor = 'rgb(0,112,141)';
      	var lineOpacity = (lineOpacityValue != undefined) ? lineOpacityValue : '0.4';

      	if(feature.properties.prop85 && feature.properties.prop85.value != '' && feature.properties.prop85.value != null) {
      		lineColor = feature.properties.prop85.value;
      	}
      	else if(iconInfo != undefined && iconInfo != 0) {
      		lineColor = iconInfo.color;
      	}

        if(tag.id == 115 || tag.id == 117) {
      		var preWarning = false;
      		if(feature.properties.prop89) {
      			preWarning = MarkerGenerator.checkWarningPeriod(feature);
      		}
      		if(preWarning == true) {
      			lineColor = 'rgb(96,96,96)';
      		}
      	}

      	feature.lineStyle = {'color': lineColor, 'weight': 5, 'opacity': lineOpacity};
        resolve();
      });
    });
  },

  //User wish colors
  findUserWishColor: function(feature) {
  	var fill = '#ff99cc';
  	var userWishStyle = MarkerGenerator.userWishStyles.filter(obj => obj[0] == feature.properties.prop120.option_id);

  	if(userWishStyle[0][2][0] != undefined) {
  		fill = userWishStyle[0][2][0];
  	}

  	return fill;
  },

  //User wish icon
  findUserWishIcon: function(feature) {
  	var icon = '';
  	var userWishStyle = MarkerGenerator.userWishStyles.filter(obj => obj[0] == feature.properties.prop120.option_id);

  	if(userWishStyle[0][2][2] != undefined) {
  		icon = '<img src="/img/customUseIcons/'+userWishStyle[0][2][2]+'" alt="Brugerønske kort ikon">';
  	}
  	else {
  		icon = '<span class="marker-text">'+userWishStyle[0][2][1]+'</span>';
  	}

  	return icon;
  },

  //Bench colors
  findBenchColor: function(feature) {
  	//Default colour for when no properties or no info
  	var fill = 'rgb(177,171,165)';

  	if(feature.properties.prop118 && feature.properties.prop119) {
  		//var noInfoAvailable = _.find(feature.properties.prop118.value, function(obj) { return obj.option_id == 61});
  		//var noAccessInfoAvailable = _.find(feature.properties.prop119.value, function(obj) { return obj.option_id == 62});
      var noInfoAvailable = false;
      var noAccessInfoAvailable = false;

      for(var i in feature.properties.prop118.value) {
        if(feature.properties.prop118.value[i].option_id == 61) {
          noInfoAvailable = true;
        }
      }

      for(var i in feature.properties.prop119.value) {
        if(feature.properties.prop118.value[i].option_id == 62) {
          noAccessInfoAvailable = true;
        }
      }
  		//console.log(noInfoAvailable);
  		//console.log(noAccessInfoAvailable);
  		if((noInfoAvailable.value == true) || (noAccessInfoAvailable.value == true) || feature.properties.prop126.option_id == 173) {
  			//Grey
  			fill = 'rgb(177,171,165)';
  		}
  		else {
  			var infoValues = [];
  			var accessValues = [];
  			var accessProblem = false;
  			var designProblem = false;

  			for(var i in feature.properties.prop118.value) {
  				infoValues[feature.properties.prop118.value[i].option_id] = feature.properties.prop118.value[i].value;
  			}
  			for(var i in feature.properties.prop119.value) {
  				accessValues[feature.properties.prop119.value[i].option_id] = feature.properties.prop119.value[i].value;
  			}
  			//console.log(infoValues);
  			//console.log(accessValues);

				//Check for access problems
				if(accessValues[64] == true || accessValues[65] == true || accessValues[67] == true || accessValues[68] == true || accessValues[71]) {
					accessProblem = true;
				}
				//Check for design problems
				if(infoValues[55] == true || infoValues[56] == true || infoValues[57] == true || infoValues[58] == true || infoValues[59] == true|| infoValues[60] == true) {
					designProblem = true;
				}

  			if(accessProblem && designProblem) {
  				//Red
  				fill = '#A7172B';
  			}
  			else if(accessProblem || designProblem) {
  				//Yellow
  				fill = '#FFDC00';
  			}
  			else {
  				//Green
  				fill = '#009149';
  			}
  		}
  	}

  	return fill;
  },

  //Bench custom icon
  findBenchIcon: function(feature) {
  	var icon = '';
  	//console.log(feature);
  	if(feature.properties.prop126) {
  		//Bænk uden arm- og ryglæn
  		if(feature.properties.prop126.option_id == 171) {
  			icon = '<img src="/img/customUseIcons/plint.svg" alt="Ikon for bænk uden arm og ryglæn">';
  		}
  		//Bænk med arm- og ryglæn
  		else if(feature.properties.prop126.option_id == 168) {
  			icon = '<img src="/img/customUseIcons/baenk_med_armlaen.svg" alt="Ikon for bænk med arm og ryglæn">';
  		}
  		//Bænk med ryglæn
  		else if(feature.properties.prop126.option_id == 169) {
  			icon = '<img src="/img/customUseIcons/baenk.svg" alt="Ikon for bænk med ryglæn">';
  		}
  		//Bænk med armlæn
  		else if(feature.properties.prop126.option_id == 170) {
  			icon = '<img src="/img/customUseIcons/plint.svg" alt="Ikon for bænk med armlæn">';
  		}
  		//Borde-bænkesæt
  		else if(feature.properties.prop126.option_id == 172) {
  			icon = '<img src="/img/customUseIcons/bordebaenke.svg" alt="Ikon for borde-bænkesæt">';
  		}
  		//Anden opholdsmulighed
  		else if(feature.properties.prop126.option_id == 173) {
  			icon = '<img src="/img/customUseIcons/anden_opholdsmulighed.svg" alt="Ikon for anden opholdsmulighed">';
  		}
  	}

  	return icon;
  },

  isSign: function(str) {
  	// check if a feature is a sign based on the icon's name
  	return /(eg|e|l|vl|vf|u|pk|hf)(\d+(\.\d*)?)(\.png)/.test(str);
  },

  //Check if feature should be shown
  showFeature: function(feature) {
  	if(feature.properties.prop90) {
  		var bool = MarkerGenerator.checkTimePeriod(feature);
  		if(bool == false) {
  			if(feature.properties.prop89) {
  				bool = MarkerGenerator.checkWarningPeriod(feature);
  				return bool;
  			}
  			return false;
			}
			else {
				return true;
			}
  	}

  	return true;
  },

  //Check warning period
  checkWarningPeriod: function(feature) {
  	//console.log(feature);
  	if(feature.properties.prop89) {
  		var from = new Date(feature.properties.prop89.value.from);
  		var to = new Date(feature.properties.prop89.value.to);
  		if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()){
  			return true;
  		}
  		else {
  			return false;
  		}
  	}
  	return true;
  },

  //Check active period
  checkTimePeriod: function(feature) {
  	//console.log(feature.name, feature);
  	if(feature.properties.prop90) {
  		var from = new Date(feature.properties.prop90.value.from);
  		var to = new Date(feature.properties.prop90.value.to);
  		if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()){
  			return true;
  		}
  		else {
  			return false;
  		}
  	}
  	return true;
  },
};

export default MarkerGenerator;
